"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var components_1 = require("stremio/components");
var AddItem_less_1 = __importDefault(require("./AddItem.less"));
var AddItem = function (_a) {
    var onCancel = _a.onCancel, handleAddUrl = _a.handleAddUrl;
    var _b = (0, react_1.useState)(''), inputValue = _b[0], setInputValue = _b[1];
    var handleValueChange = (0, react_1.useCallback)(function (_a) {
        var target = _a.target;
        setInputValue(target.value);
    }, []);
    var onSubmit = (0, react_1.useCallback)(function () {
        handleAddUrl(inputValue);
    }, [inputValue]);
    return (react_1.default.createElement("div", { className: AddItem_less_1.default['add-item'] },
        react_1.default.createElement(components_1.TextInput, { className: AddItem_less_1.default['input'], value: inputValue, onChange: handleValueChange, onSubmit: onSubmit, placeholder: 'Enter URL' }),
        react_1.default.createElement("div", { className: AddItem_less_1.default['actions'] },
            react_1.default.createElement(components_1.Button, { className: AddItem_less_1.default['add'], onClick: onSubmit },
                react_1.default.createElement(react_2.default, { name: 'checkmark', className: AddItem_less_1.default['icon'] })),
            react_1.default.createElement(components_1.Button, { className: AddItem_less_1.default['cancel'], onClick: onCancel },
                react_1.default.createElement(react_2.default, { name: 'close', className: AddItem_less_1.default['icon'] })))));
};
exports.default = AddItem;
